// extracted by mini-css-extract-plugin
export default {"centerChildren":"Errors_centerChildren__Vi9aN"};